import styled, { StyledProps } from 'styled-components/macro';

export type ManageJobsStyleProps = StyledProps<{
  variant: 'primary' | 'secondary';
}>;

export const ManageJobs = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin: 20px;
`;

export const Title = styled.div`
  color: #333;
  font-size: 21px;
  line-height: 24px;
  margin-bottom: 10px;
`;

export const ManageJobsTable = styled.div`
  width: 100%;
  margin-top: 20px;

  .textCenter {
    text-align: center;
  }

  table {
    thead {
      tr {
        th {
          // border: none;
        }
      }
    }
    tbody {
      tr {
        td {
          &:nth-child(3),
          &:nth-child(4),
          &:nth-child(5),
          &:nth-child(6) {
            text-align: right;
          }
        }
      }
    }
  }
`;

export const TimeZoneInfo = styled.div`
  font-weight: 300;
  font-size: 12px;
  line-height: 15px;
  color: #424242;
  display: flex;
  margin-right: 15px;
  margin-left: auto;
  width: 300px;
  justify-content: flex-end;
  height: 0;
  transform: translateY(10px);
`;

export const ManageJobsContent = styled.div`
  display: flex;
  flex: 1;
`;

export const Spacer = styled.div`
  flex: 1;
`;

export const Footer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 68px;
  min-height: 68px;
  background-color: #ecf0f1;
  padding: 0 20px;
  display: flex;
  & > * {
    margin-left: 8px;
  }
`;
